import { createColumnHelper } from '@tanstack/react-table';
import { isEmpty } from 'lodash';

const formatCellView = (cellView) => {
	if (cellView === 0) return 0;

	if (isEmpty(cellView)) return '-';

	return cellView;
};

/**
 * @param { import('./useDataTable').ITableColumn } column
 * @param { Object } rowData
 * @param { number } index
 * @return { React.ReactNode } view of each row's cell
 */
const getCellView = (column, rowData, index) => {
	if (column.dataKey && column.renderer) {
		return formatCellView(
			column?.renderer(rowData[column.dataKey], rowData, index),
		);
	} else if (column.renderer) {
		return formatCellView(column?.renderer(rowData, index));
	} else if (column.dataKey) {
		return formatCellView(rowData[column.dataKey]);
	}
	return formatCellView(null);
};

/**
 * @template D
 * @param { import('./useDataTable').ITableColumn[] } columns
 * @returns { import('@tanstack/react-table').ColumnDef<D, import('./useDataTable').ITableColumn }
 */
export const getColumnsDefinitions = (columns) => {
	const columnHelper = createColumnHelper();
	return columns.map((column) =>
		columnHelper.accessor(
			(rowData, index) => getCellView(column, rowData, index),
			{
				id: column.id,
				cell: (info) => info.getValue(),
				header: column.title,
				meta: { ...column, ...(!column?.align && { align: 'left' }) },
			},
		),
	);
};

/**
 * @param { string[] } hiddenColumns
 * @returns { Record<string, boolean> }
 */
export const getColumnsVisibility = (hiddenColumns) => {
	return hiddenColumns.reduce((columnsState, columnId) => {
		columnsState[columnId] = false;
		return columnsState;
	}, {});
};
